module.exports = __webpack_public_path__ + "assets/img/icon-arrow.58f9da15.svg";